import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AbstractAspect } from '@adornis/filter/aspect-schemas/AbstractAspect.js';
import type { AspectConfig } from '@adornis/filter/filter-options.js';
import { Subject } from '@chancenwerk/enums/enums.js';
import { html } from 'lit';

@Entity()
export class GraduationSubjectAspect extends AbstractAspect {
  static override _class = 'GraduationSubjectAspect';

  constructor(doc: PartialEntityData<GraduationSubjectAspect>) {
    const newDoc = {
      customID: 'gradSubs',
      ...doc,
    };
    super(newDoc);
  }

  @Field(() => [String]) value: Maybe<string[]>;

  override getMongoFilter(): object | null {
    if (!this.value?.length || !this.customID) return null;

    return {
      $or: [
        { 'graduationInformation.firstSubjectGraduation': { $in: this.value } },
        { 'graduationInformation.secondSubjectGraduation': { $in: this.value } },
        { 'graduationInformation.thirdSubjectGraduation': { $in: this.value } },
      ],
    };
  }
}

export const GraduationSubjectAspectSchema: AspectConfig<GraduationSubjectAspect> = {
  aspectConstructor: GraduationSubjectAspect,
  renderEditor: ({ aspectValue }) => html`
    <cr-dropdown-selection
      placeholder="Fächer"
      placeholder-mode="hide"
      .selectables=${Object.values(Subject)}
      @value-picked=${(e: ValueEvent<Maybe<string>>) => {
        if (e.detail.value) {
          aspectValue.value = [e.detail.value];
        } else {
          aspectValue.value = [];
        }
      }}
      .valueID=${aspectValue.value}
    ></cr-dropdown-selection>
  `,
  renderPreview: ({ aspectValue }) => (aspectValue.value ? html` ${aspectValue.value} ` : null),
};
